import { forwardRef } from 'react';
import type { BaseInputProps, InputProps } from './types';

type Props = BaseInputProps & InputProps<'text'> & { displayValue?: string };

export const Input = forwardRef<HTMLInputElement, Props>(({ value = '', type = 'text', ...rest }, ref) => {
  const { displayValue, ...otherProps } = rest;
  return <input value={value} type={type} {...otherProps} ref={ref} />;
});

Input.displayName = 'Input';
